<div
    class="category-container casino-mobile-epcot-navigation"
    [class]="{ 'casino-non-touch-device': !config().isTouch, 'casino-touch-device': config().isTouch }">
    @for (scrollButton of scrollButtons(); track scrollButton.id) {
        @if (!config().isTouch && scrollButton.condition) {
            <div class="casino-carousel-bg {{ scrollButton.direction }}-sec">
                <div
                    class="scroll-btn theme-{{ scrollButton.direction }} {{ scrollButton.direction }}"
                    (click)="scrollButton.clickHandler($event)"></div>
            </div>
        }
    }

    <div #epcotNavTabContent #epcotNavContainer class="resizable-container epcot-nav" [class]="{ 'casino-touch-device': config().isTouch }">
        @if (showFixedNavPill()) {
            <cc-fixed-navigation
                [config]="config()"
                [defaultPageText]="defaultPageText()"
                [currentTheme]="currentTheme"
                (goToUrl)="handleGoToUrl($event)"
                (goToPromotionPage)="handleGoToPromotionPage()"
                (goToDefaultPage)="handleGoToDefaultPage($event)"
                (showSearch)="handleShowSearch()">
            </cc-fixed-navigation>
        }

        @if (showMobileNav()) {
            <div [class]="{ fixedMobileNav: config().enableFixedMobileNavigation }" (scroll)="handleThumbnailScroll()">
                @if (extendTopMenuState() && !config().extendedTopMenuToRight) {
                    <cc-mobile-navigation
                        [config]="config()"
                        [extendTopMenuState]="extendTopMenuState()"
                        [extendTopMenu]="extendTopMenu()"
                        [currentTheme]="currentTheme"
                        (goToUrl)="handleGoToUrl($event)">
                    </cc-mobile-navigation>
                }
                <cc-category-navigation
                    [config]="config()"
                    [navItems]="navItems()"
                    [processedMyNavCategories]="processedMyNavCategories()"
                    [defaultCategoryType]="defaultCategoryType()"
                    [currentTheme]="currentTheme"
                    (thumbnailScroll)="handleThumbnailScroll()"
                    (extentRightMenuTracking)="handleChildExtentRightMenuTracking($event)"
                    (setActiveMobile)="handleSetActiveMobile($event)"
                    (categoryTracking)="handleChildCategoryTracking($event)">
                </cc-category-navigation>
            </div>
        }
    </div>
</div>
